export default "__VITE_ASSET__HL17gkHz__"